import React from 'react'
import Chart from 'react-apexcharts'

const PieChart = ({ data }) => {
  const defaultData = [75.9999, 25.99999]
  const femaleCount = data?.femaleCount || 0
  const maleCount = data?.maleCount || 0
  const totalStudents = data?.studentCount || 0
  const seriesData = totalStudents > 0 ? [femaleCount, maleCount] : defaultData
  const chartOptions = {
    labels: ['Female', 'Male'],
    colors: totalStudents > 0 ? ['#0040C1', '#3C45FF'] : ['#b7b4b4', '#b7b4b4'],
    legend: {
      show: false,
    },
    plotOptions: {
      pie: {
        dataLabels: {
          offset: 0,
        },
      },
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: function (val) {
          // return Math.round(val) + ' (' + ((val / totalStudents) * 100).toFixed(2) + '%)';
          return Math.round(val)
        },
      },
    },
  }
  return (
    <div className="app">
      <div className="row">
        <div className="mixed-chart">
          <Chart options={chartOptions} series={seriesData} type="pie" width="300" />
        </div>
      </div>
    </div>
  )
}

export default PieChart
